import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetPresignedDownloadURLForRespondentsWithFiltersForRespondentModuleRPC } from "./getPresignedDownloadUrlForRespondentsWithFiltersForRespondentModuleRPC";

export class GetPresignedDownloadURLForRespondentsWithFiltersForRespondentModuleRPCClientImpl extends GetPresignedDownloadURLForRespondentsWithFiltersForRespondentModuleRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetPresignedDownloadURLForRespondentsWithFiltersForRespondentModuleRPC.Request): Promise<LeoRPCResult<GetPresignedDownloadURLForRespondentsWithFiltersForRespondentModuleRPC.Response, GetPresignedDownloadURLForRespondentsWithFiltersForRespondentModuleRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "respondent/GetPresignedDownloadURLForRespondentsWithFiltersForRespondentModule",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetPresignedDownloadURLForRespondentsWithFiltersForRespondentModuleRPC.ResponseDTO,
      GetPresignedDownloadURLForRespondentsWithFiltersForRespondentModuleRPC.Errors.ErrorsDTO,
      GetPresignedDownloadURLForRespondentsWithFiltersForRespondentModuleRPC.Response,
      GetPresignedDownloadURLForRespondentsWithFiltersForRespondentModuleRPC.Errors.Errors
    >(
      response,
      "respondent/GetPresignedDownloadURLForRespondentsWithFiltersForRespondentModule",
      GetPresignedDownloadURLForRespondentsWithFiltersForRespondentModuleRPC.Response.fromDTO,
      GetPresignedDownloadURLForRespondentsWithFiltersForRespondentModuleRPC.Errors.fromDTO
    );
  }
}
